const DEFAULT_LATITUDE = 35.9183423;
const DEFAULT_LONGITUDE = -95.163601;
const DEFAULT_ZOOM = 5;
const MIN_ZOOM = 3;
const CENTER_POSITION = [DEFAULT_LATITUDE, DEFAULT_LONGITUDE, DEFAULT_ZOOM];
const ZOOM_CONTROL_POSITION = 'bottomright';

export { CENTER_POSITION, DEFAULT_ZOOM, MIN_ZOOM, ZOOM_CONTROL_POSITION };
